import React from 'react';
import { withGoogleMap, GoogleMap as LibGoogleMap, Marker as LibMarker, InfoWindow as LibInfoWindow } from 'react-google-maps';

export const MarkerIconSVG = 'M14.5,1C7,1.1,0.9,7.2,1,14.7c0,0,0,0.1,0,0.1C1,22.5,14.5,41,14.5,41S28,22.5,28,14.8 C28.1,7.3,22.1,1.1,14.6,1C14.6,1,14.5,1,14.5,1z M14.5,19.8c-2.8,0-5-2.2-5-5s2.2-5,5-5s5,2.2,5,5S17.3,19.8,14.5,19.8z';

class GoogleMapHOC extends React.Component {

  componentDidMount() {
    if(this.props.myMarkers) {
      const bounds = new window.google.maps.LatLngBounds();
      this.props.myMarkers.forEach((cord) => {
        bounds.extend(new window.google.maps.LatLng(cord.lat, cord.lng));
      });
      this.elmGM.fitBounds(bounds);
    }
  }

  render() {
    return <LibGoogleMap
      ref={e => this.elmGM = e}
      {...this.props} />
  }
}

export const OrigGoogleMap = withGoogleMap(props =>
  <GoogleMapHOC
    {...props}
  />
)

export const GoogleMap = OrigGoogleMap;

export const Marker = LibMarker;

export class MarkerWithInfoWindow extends React.Component {

  constructor() {
    super();
    this.state = {
      isOpen: false
    }
    this.onToggleOpen = this.onToggleOpen.bind(this);
  }

  onToggleOpen() {
    this.props.onClick();
  }

  render() {
    const { ...props } = this.props;
    return (<LibMarker {...props}
      onClick={this.onToggleOpen}>
      {this.props.canShow && <LibInfoWindow onCloseClick={this.onToggleOpen}>
        {this.props.children}
      </LibInfoWindow>}
    </LibMarker>)
  }
}